// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card___zR2on","form-container":"styles__form-container___2nz2u","label-title":"styles__label-title___39Gl6","button":"styles__button___1AEoD"};